import React, { Component, createElement } from "react";
import {
	Menu,
	Icon,
	Spin,	
	Dropdown,
	Avatar,
	Divider,
  Tooltip
} from "antd";
import Debounce from "lodash-decorators/debounce";
import RankerXLink from "components/RankerXLink";
import styles from "./index.module.less";
import { observer } from "mobx-react";

@observer
export default class GlobalHeader extends Component {
	componentWillUnmount() {
		this.triggerResizeEvent.cancel();
	}
	toggle = () => {
		const { collapsed, onCollapse } = this.props;
		onCollapse(!collapsed);
		this.triggerResizeEvent();
	};
	@Debounce(600)
	triggerResizeEvent() {
		// eslint-disable-line
		const event = document.createEvent("HTMLEvents");
		event.initEvent("resize", true, false);
		window.dispatchEvent(event);
	}
	render() {
		const { currentUser, collapsed, isMobile, logo, onMenuClick } = this.props;
		const menu = (
			<Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
				<Menu.Item key="options">
					<RankerXLink routeName="options" target="_blank">
						<Icon type="setting" />Options
					</RankerXLink>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key="logout">
					<Icon type="logout" />Logout
				</Menu.Item>
			</Menu>
    );    

		return (
			<div className={styles.header}>
				{isMobile && [
					<RankerXLink routeName="campaigns" className={styles.logo} key="logo">
						<img src={logo} alt="logo" width="32" />
					</RankerXLink>,
					<Divider type="vertical" key="line" />
				]}
				<Icon
					className={styles.trigger}
					type={collapsed ? "menu-unfold" : "menu-fold"}
					onClick={this.toggle}
				/>				
				<div className={styles.right}>
					<Tooltip title="Usage">
						<a
							target="_blank"
							href="https://rankerx.com/guides"
							rel="noopener noreferrer"
							className={styles.action}
						>
							<Icon type="question-circle-o" />
						</a>
					</Tooltip>
					{currentUser.name ? (
						<Dropdown overlay={menu}>
							<span className={`${styles.action} ${styles.account}`}>
								<Avatar
									size="small"
									className={styles.avatar}
									src={currentUser.avatar}
								/>
								<span className={styles.name}>{currentUser.name}</span>
							</span>
						</Dropdown>
					) : (
						<Spin size="small" style={{ marginLeft: 8 }} />
					)}
				</div>
			</div>
		);
	}
}
